const Tabs = (el) => {

    if(!el){
        console.warn("Unable to initialize Tabs without an element.")
        return;
    }

    const moreDropdown = el.querySelector("li.dropdown");
    const moreMenu = el.querySelector("li.dropdown .dropdown-menu");
    const tabs = el.querySelectorAll(":scope > li:not(.dropdown)");
    const maxWidth = getMaxWidth(el);

    for(let i = tabs.length -1; i >= 0; i--){
        const tab = tabs[i];

        if(el.scrollWidth > maxWidth) {
            tab.classList.add("d-none");
            moreDropdown.classList.remove("d-none");
        }
    }

    moreMenu.innerHTML = "";
    const hiddenItems = el.querySelectorAll("li.d-none:not(.dropdown)");
    hiddenItems.forEach(hiddenItem => {

        const li = document.createElement("li");
        const link = hiddenItem.querySelector("a");
        link.className = "dropdown-item text-gray-500 fw-bold fs-5 p-5";

        li.appendChild(link);
        moreMenu.append(li);
    });
}

function getMaxWidth(el) {

    const parentProperties = window.getComputedStyle(el.parentElement);
    const paddingLeft = parseInt(parentProperties.getPropertyValue("padding-left"));
    const paddingRight = parseInt(parentProperties.getPropertyValue("padding-right"));

    return el.parentElement.clientWidth - paddingLeft - paddingRight;
}

export default Tabs
